import { createSlice } from '@reduxjs/toolkit';

interface FeedbackState {
    feedbackList: any[];
    loading: boolean;
    error: string | null;
    success: boolean;
}

const initialState: FeedbackState = {
    feedbackList: [],
    loading: false,
    error: null,
    success: false,
};

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        setSuccess: (state, action) => {
            state.success = action.payload;
            state.loading = false;
            state.error = null;
        },
        setFeedbackList: (state, action) => {
            state.feedbackList = action.payload;
            state.loading = false;
            state.error = null;
        },
        addFeedback: (state, action) => {
            state.feedbackList.unshift(action.payload);
            state.success = true;
            state.loading = false;
            state.error = null;
        },
        clearFeedbackState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        },
    },
});

export const {
    setLoading,
    setError,
    setSuccess,
    setFeedbackList,
    addFeedback,
    clearFeedbackState,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
